import React from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const textData = {
    titulo: 'Baixe nosso aplicativo',
    descricao: 'Confiança é a base do nosso compromisso com o associado. Nosso propósito é oferecer tranquilidade para quem usa seu veículo, para lazer ou trabalho. ',
    LinkApple: 'https://apps.apple.com/br/app/sga-associado/id1450081121',
    LinkGoogle: 'https://play.google.com/store/apps/details?id=br.com.hinovamobile.sgaassociado',
    imagemSrc: '/images/aplicativo-2.png',
}

const ImagemTexto: React.FC = () => {

  return (
    <section id="download" className="lg:px-14 bg-theme-gray py-12">
      <div className="flex flex-col md:flex-row items-center md:items-center md:justify-between md:space-x-8 p-6">
        <div className="mt-6 md:mt-0 md:w-1/2 flex justify-center md:justify-end">
          <img src={definicoescliente?.Aplicativo?.ImagemAplicativo ||textData.imagemSrc} alt="Imagem App" className="object-cover max-h-[500px]"/>
        </div>
        <div className="flex flex-col items-start md:self-center md:w-1/2">
          <h2 className="text-textotitulo text-theme-dark font-bold mb-4 text-center">{definicoescliente?.Aplicativo?.Titulo || textData.titulo}</h2>
          <p className="text-theme-dark mb-4 text-textopadrao text-start max-w-xl">{definicoescliente?.Aplicativo?.Descricao || textData.descricao}</p>
          <div className="flex justify-center md:justify-start space-x-4 mt-4">
            <a href={definicoescliente?.Aplicativo?.LinkApple || textData.LinkApple} target="_blank" rel="noopener noreferrer">
              <img src="/images/appstore.png" alt="Baixar na App Store" className="h-12"/>
            </a>
            <a href={definicoescliente?.Aplicativo?.LinkGoogle || textData.LinkGoogle} target="_blank" rel="noopener noreferrer">
              <img src="/images/googlestore.png" alt="Baixar no Google Play" className="h-12"/>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImagemTexto;
